export const environment = {
  production: false,
  env: 'dev',
  apiHost: 'https://qa-partner.vanbelle.com/web/portal-api',
  kcUrl: 'https://qa-partner.vanbelle.com/auth',
  kcRealm: 'YPPortal',
  kcClientId: 'yp-cportal-web',
  skipAuthentication: false,
};
